module.exports = __webpack_public_path__ + "img/FPG-2.87835b53.jpg";